<div class="country">
  <img class="country__flag" [src]="countryConfig?.flag" alt="Country Flag" />
  <label class="country__name">{{ countryConfig?.name }}</label>
</div>
